export enum PermissionServiceErrorCode {
  GENERAL,
}

export interface PermissionsServerData {
  [key: string]: boolean
}
